module.exports = __webpack_public_path__ + "img/channel_login_background.5dd1c743.jpeg";